import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import { DECORATION_GROUP_COVER } from '@constant'
import { getRealPhotoStyle } from '@components/LocalMerchant/Decoration/util'
import MerchantVideo from '../MerchantVideo/Main'
import style from './style.module.less'
import { Flex } from 'hljd'
import PhoneHeader from '../Common/PhoneHeader'
import { dGet } from '@core/utils'

/**
 * 三大团队封面
 */
@inject('decorationStore')
@observer
export default class extends Component {
  componentDidMount() {
    this.props.decorationStore.getRealPhotos()
  }

  showPhoto = (isVideoTab, videosData, real_photos) => {
    return (
      (isVideoTab && videosData.length == 0 && real_photos.length > 0) ||
      !isVideoTab
    )
  }

  /**
   * 视频是 1审核中，2审核通过，3审核失败
    图片是 0审核中，1审核通过，3审核失败
   */
  getStatus = () => {
    const { allStatus } = this.props.store
    const videoStatus = dGet(allStatus, 'merchant_video.status')
    const photoStatus = dGet(allStatus, 'pending_data.real_photos.status')

    let status = ''

    if (videoStatus == 1 || photoStatus == 0) {
      status = 'verifying'
    } else if (videoStatus == 3 || photoStatus == 3) {
      status = 'rejected'
    }

    return status
  }

  render() {
    let {
      groupCoverStore: { isVideoTab },
      real_photos,
      videosData
    } = this.props.decorationStore
    real_photos = real_photos || []
    videosData = videosData || []
    const showPhoto = this.showPhoto(isVideoTab, videosData, real_photos)

    return (
      <Rowbox
        type={DECORATION_GROUP_COVER}
        store={this.props.store}
        style={{
          ...(showPhoto
            ? getRealPhotoStyle(real_photos)
            : {
                flexDirection: 'column',
                padding: 0,
                height: 260
              }),
          marginBottom: 0
        }}
        status={this.getStatus()}
      >
        <PhoneHeader />

        {(videosData.length == 0 || !isVideoTab) && (
          <div
            style={{
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 1)',
              opacity: 0.3,
              position: 'absolute',
              zIndex: 9,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
            }}
          />
        )}

        {!showPhoto && <MerchantVideo />}

        <Flex className={style.tabs} sp>
          <Flex className={style.tab} vc>
            <img src="//qnm.hunliji.com/o_1dnc75be61hec2qn6sg6kt1bic.png" />
            <span>{videosData.length}</span>
          </Flex>
          <Flex className={style.tab} vc>
            <img src="//qnm.hunliji.com/o_1dnc75be6tidu221vosb41glfd.png" />
            <span>{real_photos.length}</span>
          </Flex>
        </Flex>
      </Rowbox>
    )
  }
}
